import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { BaseFilter } from 'ag-grid-community';
import { UserResource } from '../api-users/model/userResource';
import { UserService } from '../api-users/api/user.service';
import { CreateUserRequest } from '../api-users/model/createUserRequest';
import { UpdateUserRequest } from '../api-users/model/updateUserRequest';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    private _user: BehaviorSubject<UserResource | null> = new BehaviorSubject<UserResource | null>(null);
    private _users: BehaviorSubject<UserResource[] | null> = new BehaviorSubject<UserResource[] | null>(null);

    public actualFilter?: BaseFilter;

    constructor(private readonly _usersDsService: UserService) {}

    get user$(): Observable<UserResource | null> {
        return this._user.asObservable();
    }

    get users$(): Observable<UserResource[] | null> {
        return this._users.asObservable();
    }

    public getUser(idUser: number) {
        return this._usersDsService.getDetailUser(idUser).pipe(
            tap(user => {
                this._user.next(user);
            }),
        );
    }

    public getListUsers(
        page?: string,
        pageSize?: string,
        filter?: Array<{ [key: string]: string }>,
        sort?: string,
        companyId?: number
    ): Observable<any | { data: UserResource[]; meta?: { pagination?: { total: number } } }> {
        return this._usersDsService.getListUsers(pageSize, page, filter, sort, companyId);
    }

    public updateUser(editedUser: number, user: UpdateUserRequest): Observable<UserResource> {
        return this._usersDsService.updateUser(editedUser, user);
    }

    public createUser(user: CreateUserRequest): Observable<UserResource> {
        return this._usersDsService.createNewUser(user);
    }
    //
    // public setNewPassword(req: ResetPasswordRequest): Observable<any> {
    //     return this._authPassService.resetPassword(req);
    // }
}
